export default __webpack_public_path__ + "static/media/blueTheme-girl.232e4a4f.svg";